import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=05d3a43f&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=05d3a43f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3a43f",
  null
  
)

export default component.exports